import React, { useState, useEffect } from "react";
import {
  TextField,
  IconButton,
  InputAdornment,
  Tooltip,
  Box,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const PhoneTextField = (props) => {
  const {
    label,
    name,
    isDisabled,
    codeIsVerified,
    value: propValue,
    handleOnChange,
  } = props;

  const [encryptDecrypt, setEncryptDecrypt] = useState(true);
  const [decryptValue, setDecryptValue] = useState("");
  const [valueArray, setValueArray] = useState([]);
  const [selectedTextStartIndex, setSelectedTextStartIndex] = useState(0);
  const [selectedTextEndIndex, setSelectedTextEndIndex] = useState(0);
  console.log("name", name);
  useEffect(() => {
    if (propValue !== "" && propValue !== undefined) {
      let newValueArray = [];
      let newDecValue = "";

      for (let index = 0; index < propValue.length; index++) {
        const element = propValue[index];
        newValueArray.push(element);
        newDecValue += "*";
      }

      setDecryptValue(newDecValue);
      setValueArray(newValueArray);
    } else {
      setValueArray([]);
      setDecryptValue("");
    }
  }, [propValue]);

  const handleEncryptOnChange = (input) => {
    const { value } = input.target;
    let filterValue = value;

    if (encryptDecrypt) {
      let newValue = filterValue.replace(/\-/g, "");
      let decrypt = "";
      for (let index = 0; index < newValue.length; index++) {
        decrypt += "*";
      }
      filterValue = filterValue.replace(/[^\d]/g, "");

      let newValueArray = [...valueArray];

      if (filterValue === "") {
        let calcIndex1 = input.target.selectionStart;
        if (calcIndex1 > 7) {
          calcIndex1 = calcIndex1 - 2;
        } else {
          if (calcIndex1 > 3 && calcIndex1 < 8) calcIndex1 = calcIndex1 - 1;
        }
        if (selectedTextStartIndex !== selectedTextEndIndex) {
          for (
            let index = selectedTextEndIndex;
            index > selectedTextStartIndex;
            index--
          ) {
            let nindex = index;
            if (nindex > 7) {
              nindex = nindex - 2;
            } else {
              if (nindex > 3 && nindex < 8) nindex = nindex - 1;
            }
            newValueArray.splice(nindex, 1);
          }
        } else {
          newValueArray.splice(calcIndex1, 1);
        }
      } else {
        let calcIndex = input.target.selectionStart;
        if (calcIndex > 4 && calcIndex < 8) {
          calcIndex = calcIndex - 1;
        } else {
          if (calcIndex > 8) calcIndex = calcIndex - 2;
        }
        for (let index = 0; index < filterValue.length; index++) {
          const element = filterValue[index];
          calcIndex += index;
          newValueArray.splice(calcIndex - 1, 0, element);
        }
      }

      setValueArray(newValueArray);
      if (newValueArray.length > 0) {
        setDecryptValue(decrypt);
      } else {
        setDecryptValue("");
      }
      handleOnChange(name, newValueArray);
    } else {
      filterValue = filterValue.replace(/[^\d]/g, "");
      let newArray = [];
      for (let index = 0; index < filterValue.length; index++) {
        newArray.push(filterValue[index]);
      }
      setValueArray(newArray);
      setDecryptValue(filterValue);
      handleOnChange(name, newArray);
    }
  };

  const handleEncryptValue = () => {
    let decValue = "";
    for (let index = 0; index < valueArray.length; index++) {
      decValue += "*";
    }
    setDecryptValue(decValue);
    setEncryptDecrypt(true);
  };

  const handleDcryptValue = () => {
    let decValue = "";
    for (let index = 0; index < valueArray.length; index++) {
      const element = valueArray[index];
      decValue += element;
    }
    setDecryptValue(decValue);
    setEncryptDecrypt(false);
  };

  const formatPhoneNumber = (value) => {
    if (!value) return value;
    let phoneNumber = value;
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    }
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6)}`;
  };

  const handleMouseUp = (event) => {
    setSelectedTextStartIndex(event.target.selectionStart);
    setSelectedTextEndIndex(event.target.selectionEnd);
  };

  return (
    <Box display="flex" alignItems="center">
      <TextField
        fullWidth
        variant="outlined"
        label={label}
        name={name}
        value={formatPhoneNumber(decryptValue)}
        onChange={handleEncryptOnChange}
        onMouseUp={handleMouseUp}
        disabled={isDisabled}
        placeholder={label}
        sx={{
          "& .MuiInputBase-input": {
            fontSize: "14px",
            fontFamily: "Open Sans, sans-serif",
            fontWeight: 400,
            color: "#000000",
          },
          "& .MuiInputLabel-root": {
            fontSize: "14px",
            fontFamily: "Open Sans, sans-serif",
            fontWeight: 400,
            color: "#000000",
          },
          "& .MuiFormHelperText-root": {
            fontSize: "14px!important",
            fontFamily: "Open Sans, sans-serif",
          },
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#555555",
            color: "#555555",
            opacity: 0.9,
          },
          "& .MuiInputLabel-root.Mui-disabled": {
            color: "#333333",
            opacity: 1,
          },
          "& .MuiFormLabel-asterisk": {
            color: "red",
          },
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {!encryptDecrypt ? (
                <Tooltip title="Hide Phone Number">
                  <IconButton
                    onClick={handleEncryptValue}
                    edge="end"
                    color="error"
                  >
                    <VisibilityOff />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="Show Phone Number">
                  <IconButton
                    onClick={handleDcryptValue}
                    edge="end"
                    color="success"
                    disabled={!codeIsVerified}
                  >
                    <Visibility />
                  </IconButton>
                </Tooltip>
              )}
            </InputAdornment>
          ),
          sx: {
            backgroundColor: `${
              !formatPhoneNumber(decryptValue) ? "#f0f0f0" : "#ffffff"
            }`,
          },
        }}
        inputProps={{
          maxLength: 12, // 999-999-9999
          "aria-label": `${label} 10 Digit`,
          title: `${label} 10 Digit`,
        }}
      />
    </Box>
  );
};

export default PhoneTextField;
